import { useState } from 'react'
import { api } from '../api'

export function AdminProfilePage() {
  const [pwCur, setPwCur] = useState('')
  const [pwNew, setPwNew] = useState('')
  const [pwMsg, setPwMsg] = useState<string | null>(null)

  return (
    <div className="stack">
      <div className="card stack">
        <h2 style={{ margin: 0 }}>帳號設定</h2>
        <div className="muted font-sm" style={{ marginBottom: '1rem' }}>
          在此您可以更新登入密碼。建議定期更換以保證帳號安全。
        </div>

        <h3 style={{ margin: '1rem 0 0.5rem', fontSize: '1.1rem' }}>更改我的密碼</h3>
        <form
          className="stack"
          onSubmit={async (e) => {
            e.preventDefault()
            setPwMsg(null)
            try {
              await api.changePassword(pwCur, pwNew)
              setPwCur('')
              setPwNew('')
              setPwMsg('✅ 密碼已更改。請重新登入。')
              setTimeout(() => {
                window.location.href = '/admin/login'
              }, 1500)
            } catch (err) {
              setPwMsg(err instanceof Error ? err.message : '失敗')
            }
          }}
        >
          <div className="stack" style={{ gap: '0.75rem' }}>
            <div className="stack" style={{ gap: '0.25rem' }}>
              <span className="muted font-sm">目前密碼</span>
              <input
                className="input"
                placeholder="舊密碼"
                type="password"
                value={pwCur}
                onChange={(e) => setPwCur(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>
            <div className="stack" style={{ gap: '0.25rem' }}>
              <span className="muted font-sm">新密碼 (最少 8 位)</span>
              <input
                className="input"
                placeholder="新密碼 (>=8)"
                type="password"
                value={pwNew}
                onChange={(e) => setPwNew(e.target.value)}
                required
                autoComplete="new-password"
              />
            </div>
            <button className="btn primary" type="submit" style={{ alignSelf: 'flex-start', minWidth: '120px' }}>
              更新密碼
            </button>
          </div>
          {pwMsg ? <div className={`muted font-sm ${pwMsg.includes('✅') ? 'success' : 'error'}`} style={{ marginTop: '0.75rem' }}>{pwMsg}</div> : null}
        </form>
      </div>
    </div>
  )
}
